// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/* overridden by src/lib/themes/guiHelpers.js */

.backpack_backpack-container_H0IKY {
  flex-shrink: 1;
  position: relative;
}

.backpack_backpack-header_Gay3u {
  margin-top: 0px;
  border-top: 1px solid var(--ui-black-transparent);
  border-right: 1px solid var(--ui-black-transparent);
  background: var(--ui-white);
  padding: 0.25rem;
  text-align: center;
  font-size: 0.85rem;
  color: var(--text-primary);
  transition: 0.2s;
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}

/*
[dir="ltr"] .backpack-header {
    border-top-right-radius: \$space;
}

[dir="rtl"] .backpack-header {
    border-top-left-radius: \$space;
}
disable */

.backpack_backpack-list_Cth_9 {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-right: 1px solid var(--ui-black-transparent);
  min-height: 5.5rem;
}

/* Absolute position the inner list to allow scrolling inside flex sized container */

.backpack_backpack-list-inner_RAXLh {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow-x: auto;
}

.backpack_drag-over_uwwc3:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.75;
  background-color: var(--drop-highlight);
  transition: all 0.25s ease;
}

.backpack_status-message_hNpAE {
  width: 100%;
  text-align: center;
  font-size: 0.85rem;
  color: var(--text-primary);
}

.backpack_error-message_BX0LX {
  font-family: monospace;
}

.backpack_backpack-item_ojrvd {
  width: 4rem;
  height: 4.5rem;
  margin: 0 0.25rem;
  flex-shrink: 0;

  /* Need to hide overflow because of background setting below */
  overflow: hidden;
}

.backpack_backpack-item_ojrvd > div {
  /* Need to set the background to get blend-mode below to work */
  background: var(--ui-primary);
}

.backpack_more_qP77W {
  background: var(--looks-secondary);
  color: var(--ui-white);
  border: none;
  outline: none;
  font-weight: bold;
  border-radius: 0.5rem;
  font-size: 0.85rem;
  padding: 0.5rem;
  margin: 0.5rem;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/backpack/backpack.css"],"names":[],"mappings":"AAAA;sDACsD;;AAEtD,+CAA+C;;AAE/C,+CAA+C;;AAE/C;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iDAAiD;EACjD,mDAAmD;EACnD,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,yBAAyB;KACtB,sBAAsB;MACrB,qBAAqB;UACjB,iBAAiB;AAC3B;;AAEA;;;;;;;;SAQS;;AAET;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mDAAmD;EACnD,kBAAkB;AACpB;;AAEA,oFAAoF;;AAEpF;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,cAAc;;EAEd,8DAA8D;EAC9D,gBAAgB;AAClB;;AAEA;EACE,+DAA+D;EAC/D,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;AACjB","sourcesContent":["/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/* overridden by src/lib/themes/guiHelpers.js */\n\n.backpack-container {\n  flex-shrink: 1;\n  position: relative;\n}\n\n.backpack-header {\n  margin-top: 0px;\n  border-top: 1px solid var(--ui-black-transparent);\n  border-right: 1px solid var(--ui-black-transparent);\n  background: var(--ui-white);\n  padding: 0.25rem;\n  text-align: center;\n  font-size: 0.85rem;\n  color: var(--text-primary);\n  transition: 0.2s;\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n\n/*\n[dir=\"ltr\"] .backpack-header {\n    border-top-right-radius: $space;\n}\n\n[dir=\"rtl\"] .backpack-header {\n    border-top-left-radius: $space;\n}\ndisable */\n\n.backpack-list {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  border-right: 1px solid var(--ui-black-transparent);\n  min-height: 5.5rem;\n}\n\n/* Absolute position the inner list to allow scrolling inside flex sized container */\n\n.backpack-list-inner {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  overflow-x: auto;\n}\n\n.drag-over:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0.75;\n  background-color: var(--drop-highlight);\n  transition: all 0.25s ease;\n}\n\n.status-message {\n  width: 100%;\n  text-align: center;\n  font-size: 0.85rem;\n  color: var(--text-primary);\n}\n\n.error-message {\n  font-family: monospace;\n}\n\n.backpack-item {\n  width: 4rem;\n  height: 4.5rem;\n  margin: 0 0.25rem;\n  flex-shrink: 0;\n\n  /* Need to hide overflow because of background setting below */\n  overflow: hidden;\n}\n\n.backpack-item > div {\n  /* Need to set the background to get blend-mode below to work */\n  background: var(--ui-primary);\n}\n\n.more {\n  background: var(--looks-secondary);\n  color: var(--ui-white);\n  border: none;\n  outline: none;\n  font-weight: bold;\n  border-radius: 0.5rem;\n  font-size: 0.85rem;\n  padding: 0.5rem;\n  margin: 0.5rem;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backpack-container": `backpack_backpack-container_H0IKY`,
	"backpackContainer": `backpack_backpack-container_H0IKY`,
	"backpack-header": `backpack_backpack-header_Gay3u`,
	"backpackHeader": `backpack_backpack-header_Gay3u`,
	"backpack-list": `backpack_backpack-list_Cth_9`,
	"backpackList": `backpack_backpack-list_Cth_9`,
	"backpack-list-inner": `backpack_backpack-list-inner_RAXLh`,
	"backpackListInner": `backpack_backpack-list-inner_RAXLh`,
	"drag-over": `backpack_drag-over_uwwc3`,
	"dragOver": `backpack_drag-over_uwwc3`,
	"status-message": `backpack_status-message_hNpAE`,
	"statusMessage": `backpack_status-message_hNpAE`,
	"error-message": `backpack_error-message_BX0LX`,
	"errorMessage": `backpack_error-message_BX0LX`,
	"backpack-item": `backpack_backpack-item_ojrvd`,
	"backpackItem": `backpack_backpack-item_ojrvd`,
	"more": `backpack_more_qP77W`
};
export default ___CSS_LOADER_EXPORT___;
